import { doc, getFirestore, addDoc, collection, connectFirestoreEmulator } from "firebase/firestore"
import { Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { addPlayer } from "../reducers/gameReducer";
import { useHistory } from 'react-router-dom'
import { useState } from "react";
import { updateGameStateFromFirestore, updatePlayerInFirestore } from "../services/gameService";

const Home = () => {
  const db = getFirestore()
  // LOCAL EMULATION
  if (process.env.NODE_ENV !== 'production') connectFirestoreEmulator(db, 'localhost', 8080);
  const user = useSelector(state => state.user)
  const dispatch = useDispatch()
  const history = useHistory()

  const [joinCodeVisible, setJoinCodeVisible] = useState(false)
  const [joinCode, setJoinCode] = useState('')

  const handleJoin = () => {
    setJoinCodeVisible(!joinCodeVisible)
  }

  const handleGameCode = (e) => {
    setJoinCode(e.target.value)
  }

  const handleCreate = async () => {
    const gameRef = await addDoc(collection(db, "games"), {
      created: Date.now(),
      moves: [],
      host: user.uid,
      players: {},
      drawPile: [],
    })
    await updateGameStateFromFirestore(db, gameRef.id, dispatch)
    await updatePlayerInFirestore(db, user.displayName, user.uid, gameRef)
    dispatch(addPlayer({ uid: user.uid, displayName: user.displayName }))
    history.push('/lobby')
  }

  const handleJoinCode = async () => {
    const gameRef = doc(db, 'games', joinCode)
    await updatePlayerInFirestore(db, user.displayName, user.uid, gameRef)
    await updateGameStateFromFirestore(db, gameRef.id, dispatch)
    history.push('/lobby')
  }

  return (
    <div>
      <p>What would you like to do ?</p>
      <Button onClick={handleCreate} className="d-block">create game</Button>
      <Button onClick={handleJoin} className="d-block">Join game</Button>
      <input onChange={handleGameCode} type="text" style={{ display: joinCodeVisible ? '' : 'None' }}></input>
      <button onClick={handleJoinCode} style={{ display: joinCodeVisible ? 'block' : 'None' }}>join</button>
    </div >
  )
}

export default Home